/** Display formatting helpers for operator-supplied text. */

const SMALL_WORDS = new Set(["a", "an", "and", "as", "at", "but", "by", "for", "in", "of", "on", "or", "the", "to", "with"]);

/**
 * Chapter files ship dance titles in ALL CAPS ("A VERY MERRY CHRISTMAS
 * EVE"). Render them as title case; leave mixed-case titles untouched.
 */
export function displayTitle(raw: string): string {
  const trimmed = raw.trim();
  if (trimmed !== trimmed.toUpperCase()) return trimmed;
  return trimmed
    .toLowerCase()
    .split(/\s+/)
    .map((word, index) => {
      if (index > 0 && SMALL_WORDS.has(word)) return word;
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");
}

export function eventDateLabel(isoDate: string): string {
  return new Date(`${isoDate}T12:00:00`).toLocaleDateString(undefined, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric"
  });
}

/** Compact hero metadata: the recital context already supplies year and title. */
export function compactEventDateLabel(isoDate: string): string {
  const date = new Date(`${isoDate}T12:00:00`);
  const day = date.getDate();
  const tens = day % 100;
  const suffix =
    tens >= 11 && tens <= 13
      ? "th"
      : day % 10 === 1
        ? "st"
        : day % 10 === 2
          ? "nd"
          : day % 10 === 3
            ? "rd"
            : "th";
  const month = date.toLocaleDateString(undefined, { month: "long" });
  return `${month} ${day}${suffix}`;
}

/** Canonical spacing for user-visible metadata separators. */
export const DOT_SEPARATOR = " · ";

export function joinWithDot(values: Array<string | number | null | undefined | false>): string {
  return values
    .filter((value) => value !== null && value !== undefined && value !== false && value !== "")
    .join(DOT_SEPARATOR);
}
